export default "<ion-router-outlet></ion-router-outlet>"